var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuthCheckCircle = function SvgAuthCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16C949",
    d: "m41.765 62.183 24.542-24.542-1.98-1.98-22.562 22.563-11.282-11.281-1.98 1.98zm5.756 19.792q-7.141 0-13.432-2.71-6.29-2.71-10.942-7.358T15.78 60.979q-2.715-6.282-2.714-13.425t2.71-13.433q2.711-6.29 7.358-10.942t10.929-7.366 13.425-2.715q7.141 0 13.432 2.71 6.29 2.712 10.942 7.358 4.653 4.648 7.367 10.929t2.714 13.425q0 7.142-2.71 13.432-2.712 6.29-7.358 10.942-4.647 4.653-10.929 7.367t-13.425 2.714m-.017-2.77q13.262 0 22.465-9.204t9.203-22.464q0-13.26-9.203-22.464-9.204-9.204-22.464-9.204-13.262 0-22.465 9.204-9.203 9.202-9.203 22.464 0 13.26 9.203 22.464 9.204 9.203 22.465 9.203"
  })));
};
export default SvgAuthCheckCircle;